var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"ui icon button tiny",attrs:{"to":{name: 'drive/file', params: { inode_id: _vm.inode.id} }}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm._f("truncate")(_vm.inode.download_name,30)))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }